/* ==========================================================================
   Hanuman Cacao — Produktseite: Variantenauswahl + Bildergalerie

   Galerie: ein Leitbild (Stage) + Miniaturen. Klick auf eine Miniatur oder
   Wisch auf der Stage wechselt das Bild. Variantenwechsel ruft dieselbe
   Umschalt-Funktion auf, damit Block/Drops-Varianten mit komplett
   unterschiedlichem Aussehen (Nachtrag 04.09.2026) weiterhin automatisch das
   passende Bild zeigen — vorausgesetzt die Variante hat im Admin ein
   zugewiesenes Bild (featured_media).
   ========================================================================== */

(function () {
  'use strict';

  function activateThumb(gallery, thumb) {
    if (!gallery || !thumb) return;
    var stageImg = gallery.querySelector('[data-hc-stage-img]');
    if (!stageImg) return;

    var full = thumb.getAttribute('data-full');
    var alt = thumb.getAttribute('data-alt') || '';
    if (full) stageImg.setAttribute('src', full);
    stageImg.setAttribute('alt', alt);
    if (thumb.dataset.mediaId) {
      stageImg.dataset.mediaId = thumb.dataset.mediaId;
    }

    var thumbs = gallery.querySelectorAll('[data-hc-gallery-thumb]');
    Array.prototype.forEach.call(thumbs, function (t) {
      var active = t === thumb;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function initVariants(root) {
    var scope = root || document;
    var dataEl = scope.querySelector('[data-hc-variants]');
    var selects = scope.querySelectorAll('[data-hc-option-index]');
    if (!dataEl || !selects.length) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; // Kaputtes JSON darf die Seite nicht mitreißen
    }

    var idInputs = scope.querySelectorAll('input[name="id"]');
    var priceEl = scope.querySelector('.hc-price__amount');
    var unitEl = scope.querySelector('[data-hc-price-unit]');

    // Grundpreis je Variante (§ 4 PAngV). Ohne das blieb beim Variantenwechsel
    // der Grundpreis der zuerst gewählten Variante stehen — 250 g und 1000 g
    // haben aber unterschiedliche Preise je Kilo. Ein stehengebliebener
    // Grundpreis ist eine falsche Preisangabe, kein Schönheitsfehler.
    var unitPrices = {};
    var unitDataEl = scope.querySelector('[data-hc-unit-prices]');
    if (unitDataEl) {
      try {
        unitPrices = JSON.parse(unitDataEl.textContent) || {};
      } catch (e) {
        unitPrices = {}; // Kaputtes JSON darf die Seite nicht mitreißen
      }
    }
    var submitButtons = scope.querySelectorAll('.hc-pdp__atc button[type="submit"], .hc-sticky-atc button[type="submit"]');
    var gallery = scope.querySelector('[data-hc-gallery]');

    function showVariantImage(v) {
      if (!gallery || !v || !v.featured_media) return;
      var thumb = gallery.querySelector('[data-hc-gallery-thumb][data-media-id="' + v.featured_media.id + '"]');
      if (!thumb) return; // Bild existiert, ist der Variante im Admin aber nicht zugewiesen
      activateThumb(gallery, thumb);
    }

    function formatMoney(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€' + parts.join(',');
    }

    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) {
        return s.value;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function apply() {
      var v = findVariant(currentOptions());

      Array.prototype.forEach.call(idInputs, function (input) {
        input.value = v ? v.id : '';
        input.disabled = !v || !v.available;
      });

      if (v && priceEl) {
        priceEl.textContent = formatMoney(v.price);
      }

      if (v && unitEl) {
        var unit = unitPrices[v.id];
        if (unit) {
          unitEl.textContent = unit;
          unitEl.hidden = false;
        } else if (!unitEl.hasAttribute('data-hc-price-unit-static')) {
          // Diese Variante hat keinen gepflegten Grundpreis, eine andere schon.
          // Lieber gar keine Angabe als die der vorherigen Variante.
          unitEl.hidden = true;
        }
      }

      showVariantImage(v);

      Array.prototype.forEach.call(submitButtons, function (btn) {
        var span = btn.querySelector('span');
        btn.disabled = !v || !v.available;
        if (span) {
          if (!v) span.textContent = 'Nicht verfügbar';
          else if (!v.available) span.textContent = 'Ausverkauft';
          else span.textContent = btn.dataset.hcLabel || span.textContent;
        }
      });

      if (v) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener('change', apply);
    });

    // Ohne diesen Aufruf zeigt die Galerie beim ersten Laden das erste Bild
    // aus product.media statt dem der vorausgewählten Variante — bei einem
    // Produkt fiel das nie auf, bei mehreren Varianten mit unterschiedlichem
    // Aussehen (Block vs. Drops) schon.
    apply();
  }

  function initGallery(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll('[data-hc-gallery]');

    Array.prototype.forEach.call(galleries, function (gallery) {
      if (gallery.dataset.hcGalleryInit) return;
      gallery.dataset.hcGalleryInit = 'true';

      var thumbs = gallery.querySelectorAll('[data-hc-gallery-thumb]');
      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          activateThumb(gallery, thumb);
        });
      });

      function step(direction) {
        var thumbsArr = Array.prototype.slice.call(gallery.querySelectorAll('[data-hc-gallery-thumb]'));
        if (!thumbsArr.length) return;
        var currentIndex = 0;
        for (var i = 0; i < thumbsArr.length; i++) {
          if (thumbsArr[i].classList.contains('is-active')) {
            currentIndex = i;
            break;
          }
        }
        var nextIndex = (currentIndex + direction + thumbsArr.length) % thumbsArr.length;
        activateThumb(gallery, thumbsArr[nextIndex]);
      }

      var prevBtn = gallery.querySelector('[data-hc-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-hc-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

      var stage = gallery.querySelector('[data-hc-gallery-stage]');
      if (!stage) return;

      var startX = null;
      var startY = null;

      stage.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        startX = null;
        startY = null;
        // Vertikales Scrollen (Seite) darf nicht als Wisch gewertet werden.
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  function initAll(root) {
    initVariants(root);
    initGallery(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
